import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { KirsAssessmentActions } from './kirs-assessment.actions';
import { KirsAssessmentService } from '../../service/kirs-assessment.service';
import { MessageService } from 'primeng/api';


@Injectable()
export class KirsAssessmentEffects {

  loadKirsAssessment$ = createEffect(
    (cd: KirsAssessmentService = inject(KirsAssessmentService)) => {
      return this.actions$.pipe(

        ofType(KirsAssessmentActions.loadKirsAssessments),
        mergeMap(({ campaignId, parameters, attestationId, legalEntityIds }) =>
          cd.getKirsAssessment(campaignId, attestationId, legalEntityIds, parameters).pipe(
            map((giasAssessments) => {
              return KirsAssessmentActions.loadKirsAssessmentsSuccess({
                giasAssessments
              });
            }),
            catchError((error) => of(KirsAssessmentActions.loadKirsAssessmentsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadAllGiasAssessment$ = createEffect(
    (cd: KirsAssessmentService = inject(KirsAssessmentService)) => {
      return this.actions$.pipe(

        ofType(KirsAssessmentActions.loadAllKirsAssessments),
        mergeMap(({ campaignId, parameters, attestationId, legalEntityIds }) =>
          cd.getKirsAssessment(campaignId, attestationId, legalEntityIds, parameters).pipe(
            map((giasAssessments) => {
              return KirsAssessmentActions.loadAllKirsAssessmentsSuccess({
                giasAssessments
              });
            }),
            catchError((error) => of(KirsAssessmentActions.loadAllKirsAssessmentsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  createAndSignAssessment$ = createEffect(
    (
      cd: KirsAssessmentService = inject(KirsAssessmentService),
      messageService: MessageService = inject(MessageService)
    ) => {
      return this.actions$.pipe(
        ofType(KirsAssessmentActions.createAndSignKirsAssessments),
        mergeMap(({ campaignId, legalEntityTrackingId, input }) =>
          cd.createAndSignKirsAssessment(campaignId, legalEntityTrackingId, input).pipe(
            map((giasAssessments) =>
              KirsAssessmentActions.createAndSignKirsAssessmentsSuccess({ giasAssessments })
            ),
            catchError((error) => {
              messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error?.graphQLErrors?.[0]?.message || error?.message || 'An error occurred while signing the KIRs attestation',
                life: 10000
              });
              return of(KirsAssessmentActions.createAndSignKirsAssessmentsFailure({ error }));
            })
          )
        )
      );
    },
    { functional: true }
  );


  exportKirsAssessments$ = createEffect(
    (ks: KirsAssessmentService = inject(KirsAssessmentService)) => {
      return this.actions$.pipe(
        ofType(KirsAssessmentActions.exportKirsAssessments),
        mergeMap(({ campaignId, parameters, timeZone, attestationId, legalEntityIds }) =>
          ks.exportKirsAssessment(campaignId, attestationId, legalEntityIds, timeZone, parameters).pipe(
            map((file) => {
              // Download diretto del file (se presente)
              if (file?.data && file.data.length > 0) {
                const f = file.data[0];
                const byteChars = atob(f!.content);
                const byteNumbers = new Array(byteChars.length);
                for (let i = 0; i < byteChars.length; i++) {
                  byteNumbers[i] = byteChars.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                const link = window.document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = f!.filename ?? "kirs-assessment.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
              }
              return KirsAssessmentActions.exportKirsAssessmentsSuccess({
                export: file
              });
            }),
            catchError((error) => of(KirsAssessmentActions.exportKirsAssessmentsFailure({ error })))
          )
        )
      )
    }
  );



  constructor(private actions$: Actions) { }
}
